import axios from 'axios';
import { MSCLogin } from './MSCLogin';
import Swal from 'sweetalert2';

// window.addEventListener('storage', function(e) {
//   console.log(e.key);
//   if (e.key === 'token')  {
//     console.log('ssss');
//     client = axios.create({
//       baseURL: process.env.REACT_APP_SERVER_API,
//       headers: { 'auth-token': localStorage.getItem("token")}
//     });
//     console.log(client);
//   }
//  });

// const tokenURL = `${process.env.REACT_APP_SERVER_API}/users/token`;

/**
 * Request Wrapper with default success/error actions
 */

const MSCrequest = async function (options) {
  let client = axios.create({
    baseURL: localStorage.getItem('MSC_API'),
    headers: { Authorization: localStorage.getItem('msc-token') },
  });
  const onSuccess = async function (response) {
    console.debug('Request Successful!', response);
    // await axios
    //   .post(`${localStorage.getItem('MSC_API')}/iam/v1/sso/refresh`, {
    //     refreshToken: localStorage.getItem('msc-refresh'),
    //   })
    //   .then((res) => {
    //     localStorage.setItem('msc-token', res?.data?.responsePayload?.access_token);
    //     localStorage.setItem('msc-refresh', res?.data?.responsePayload?.refresh_token);
    //     // console.log('send refreshtoken success');
    //   })
    //   .catch(async () => {
    //     await MSCLogin();
    //   });
    return response;
  };

  const onError = async function (error) {
    console.error('Request Failed:', error.config);

    if (error.response) {
      // Request was made but server responded with something
      // other than 2xx
      console.log(error.response.status);
      // if (error.response.status === 400) {
      //   await axios
      //     .post(`${localStorage.getItem('MSC_API')}/iam/v1/sso/refresh`, {
      //       refreshToken: localStorage.getItem('msc-refresh'),
      //     })
      //     .then((res) => {
      //       console.log('send refreshtoken fail then send');
      //       localStorage.setItem('msc-token', res?.data?.responsePayload?.access_token);
      //       localStorage.setItem('msc-refresh', res?.data?.responsePayload?.refresh_token);
      //     })
      //     .catch(async () => {
      //       console.log('error refresh then login');
      //       await MSCLogin();
      //     });
      // }
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
      console.error('Headers:', error.response.headers);
    } else {
      // Something else happened while setting up the request
      // triggered the error
      console.error('Error Message:', error.message);
    }

    return Promise.reject(error);
  };

  return client(options).then(onSuccess).catch(onError);
};

export default MSCrequest;
